import styled from 'styled-components';
import { Collapse } from 'antd';

export const CollapseWrapper = styled(Collapse)`
	border: none !important;
	border-radius: 8px !important;

	.ant-collapse-content-box {
		padding: 0;

		.ant-form {
			padding: 40px;
		}
	}

	&.ant-collapse {
		background-color: #f8f8f8 !important;
	}

	.ant-collapse-item {
		border: none !important;
	}

	.ant-collapse-header {
		border-radius: 8px !important;
		padding: 17px 17px 17px 30px !important;
	}

	.ant-collapse-content {
		border: none !important;
		border-radius: 0 0 8px 8px !important;
	}
`;
